import { render, staticRenderFns } from "./organization-admin.vue?vue&type=template&id=010d9884"
import script from "./organization-admin.vue?vue&type=script&lang=js"
export * from "./organization-admin.vue?vue&type=script&lang=js"
import style0 from "./organization-admin.vue?vue&type=style&index=0&id=010d9884&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports